import { render, staticRenderFns } from "./RememberStatistics.vue?vue&type=template&id=4abefd1e&scoped=true&"
import script from "./RememberStatistics.vue?vue&type=script&lang=ts&"
export * from "./RememberStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./RememberStatistics.vue?vue&type=style&index=0&id=4abefd1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abefd1e",
  null
  
)

export default component.exports